import React, { useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import "../../../assets/css/Staff/Staff.css"
import {
  Container,
  Table,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
// components 
import SeoReportDashboard from "./SeoReportDashboard"
import SeoReport from "./SeoReport"

const SeoReportIndex = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1")

  document.title = "SEO Report | Zithas Crm"

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab)
    }
  }

  const [fixedSideTab, setFixedSideTab] = useState(false)

  document.addEventListener("scroll", () => {
    if (window.scrollY > 68) {
      setFixedSideTab(true)
    } else {
      setFixedSideTab(false)
    }
  })

  return (
    <React.Fragment>
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Seo Report" />

          <Row className="gx-4 justify-content-between di-flex align-items-top" >
            <Col md="2" className="px-0 h-100">
              <Nav
                pills
                className={`side-tab flex-column px-2 py-3 bg-white  ${fixedSideTab ? "fixed-side-tab" : ""
                  } h-100`}
                style={{ minHeight: '80vh' }}
              >

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "1",
                    })}
                    onClick={() => {
                      toggleVertical("1")
                    }}
                  >
                    Final Report
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "2",
                    })}
                    onClick={() => {
                      toggleVertical("2")
                    }}
                  >
                    Keywords Ranking
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "3",
                    })}
                    onClick={() => {
                      toggleVertical("3")
                    }}
                  >
                    Seo Charts
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md="10" className="pe-0">
              <TabContent
                activeTab={verticalActiveTab}
                className="text-muted mt-4 mt-md-0"
              >
                <TabPane tabId="1">
                  <SeoReport heading={"Final Report"} isFinalReport={true} />
                </TabPane>
                <TabPane tabId="2">
                  <SeoReport heading={"Keywords Ranking"} />
                </TabPane>
                <TabPane tabId="3">
                  <SeoReportDashboard heading={"Final Report"} isFinalReport={true} />
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SeoReportIndex
